(() => {
  if (window.GNGOptions) return;
  const memory = new Map();
  const namePattern = /^[\p{L}\p{M}][\p{L}\p{M}\s''\-]*$/u;
  const controls = form => Array.from(form.elements).filter(el => el.matches?.('[data-gng-input], .gng-wildlife-options__select'));
  const getRoot = form => form.querySelector('[data-gng-options-root]');
  const messages = root => JSON.parse(root.querySelector('[data-gng-messages]').textContent);
  const scope = root => root.closest('[data-ui-component]') || root.closest('.shopify-section') || document;
  const key = (root, input) => `${root.dataset.product}:${root.dataset.form}:${input.name}`;
  function textSelected(root, form) {
    const selected = scope(root).querySelector('input[name="Personalization"]:checked, select[name="Personalization"], select[name="options[Personalization]"]');
    if (selected) return selected.value === 'Text';
    const variants = JSON.parse(root.querySelector('[data-gng-variants]').textContent);
    return variants.find(v => String(v.id) === String(form.elements.namedItem('id')?.value))?.options?.includes('Text') === true;
  }
  function errorFor(input, copy) {
    if (input.disabled) return '';
    if (input.dataset.gngFileRetry) return copy.file_retry;
    if (input.required && !input.value.trim()) return copy.required;
    if (input.hasAttribute('data-gng-name-only') && input.value && !namePattern.test(input.value.trim())) return copy.name;
    if (input.maxLength > 0 && input.value.length > input.maxLength) return copy.length;
    if (input.type === 'file' && input.files[0]?.size === 0) return copy.file_invalid;
    return '';
  }
  function displayError(input, message) {
    input.setCustomValidity(message);
    input.toggleAttribute('aria-invalid', !!message);
    if (message) input.setAttribute('aria-invalid', 'true');
    const field = input.closest('[data-gng-field]');
    const output = field?.querySelector('[data-gng-error]');
    if (output) { output.textContent = message; output.hidden = !message; }
  }
  function updateField(input, root) {
    const field = input.closest('[data-gng-field]');
    if (!field) return;
    const count = field.querySelector('[data-gng-count]');
    if (count) count.textContent = count.textContent.replace(/^\d+/, String(input.value.length));
    if (input.type === 'file') {
      const copy = messages(root), file = input.files[0];
      field.querySelector('[data-gng-file-status]').textContent = file ? `${copy.file_selected} ${file.name}` : input.dataset.gngFileRetry ? copy.file_retry : copy.file_empty;
      field.querySelector('[data-gng-remove]').hidden = !file && !input.dataset.gngFileRetry;
    }
  }
  function sync(root, restore = false) {
    const form = document.getElementById(root.dataset.form);
    if (!form) return;
    const isText = textSelected(root, form);
    root.querySelectorAll('[data-gng-field]').forEach(field => {
      const input = field.querySelector('[data-gng-input]');
      if (restore && memory.has(key(root,input))) {
        const saved = memory.get(key(root,input));
        if (input.type !== 'file') input.value = saved;
        else if (saved && !input.files.length) {
          try { const transfer = new DataTransfer(); transfer.items.add(saved); input.files = transfer.files; }
          catch (_) { input.dataset.gngFileRetry = 'true'; }
        }
      }
      const active = !field.dataset.gngCondition || isText;
      field.hidden = !active; input.disabled = !active;
      input.required = active && input.dataset.gngRequired === 'true';
      if (!active) displayError(input,'');
      updateField(input,root);
    });
  }
  function validate(form) {
    const root = getRoot(form);
    if (!root) return false;
    sync(root);
    const copy = messages(root), inputs = controls(form);
    const picker = inputs.find(input => input.matches?.('.gng-wildlife-options__select'))?.closest('gng-wildlife-picker');
    if (picker?.dataset.ready === 'true' && !picker.reportSelectionValidity()) return false;
    inputs.forEach(input => displayError(input,errorFor(input,copy)));
    const invalid = inputs.find(input => !input.disabled && !input.checkValidity());
    root.querySelector('[data-gng-summary]').hidden = !invalid;
    if (invalid) { invalid.scrollIntoView({block:'center',behavior:'smooth'}); invalid.focus({preventScroll:true}); invalid.reportValidity(); return false; }
    return true;
  }
  function init(root) {
    if (root.dataset.ready) return;
    const form = document.getElementById(root.dataset.form);
    if (!form) return;
    root.dataset.ready = 'true';
    form.enctype = 'multipart/form-data';
    form.addEventListener('submit', event => {
      if (!validate(form)) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    form.addEventListener('formdata', event => {
      controls(form).filter(input => input.type === 'file' && !input.files.length).forEach(input => event.formData.delete(input.name));
    });
    if (root.querySelector('[data-gng-wildlife-marker]')) root.querySelector('[data-gng-options-copy]').hidden = true;
    sync(root,true);
  }
  const initialize = () => document.querySelectorAll('[data-gng-options-root]').forEach(init);
  document.addEventListener('input', event => {
    const input = event.target, root = input.closest?.('[data-gng-options-root]');
    if (!root || !input.matches('[data-gng-input]')) return;
    delete input.dataset.gngFileRetry;
    memory.set(key(root,input), input.type === 'file' ? input.files[0] : input.value);
    updateField(input,root);
    if (input.hasAttribute('aria-invalid')) displayError(input,errorFor(input,messages(root)));
  });
  document.addEventListener('change', event => {
    const input = event.target, root = input.closest?.('[data-gng-options-root]');
    if (root && input.matches('[data-gng-input]')) {
      delete input.dataset.gngFileRetry;
      memory.set(key(root,input), input.type === 'file' ? input.files[0] : input.value);
      updateField(input,root);
    }
    document.querySelectorAll('[data-gng-options-root]').forEach(root => sync(root));
  });
  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-gng-remove]');
    if (!button) return;
    const input = button.closest('[data-gng-field]').querySelector('input');
    input.value = ''; input.dispatchEvent(new Event('input',{bubbles:true})); input.focus();
  });
  window.GNGOptions = {validate, errorFor, namePattern, networkMessage: 'Your item could not be added. Your entries are still here; please try again.'};
  initialize();
  let pending = false;
  new MutationObserver(records => {
    if (!records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1))) return;
    if (!pending) { pending = true; queueMicrotask(() => { pending = false; initialize(); }); }
  }).observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',initialize);
  window.addEventListener('pageshow',initialize);
})();
